"use client";

import { useEffect } from "react";

import { API_BASE_URL } from "@lib/config";

type BrandVisitTrackerProps = {
  vendorUid?: string | null;
  brandSlug?: string | null;
};

export default function BrandVisitTracker({ vendorUid, brandSlug }: BrandVisitTrackerProps) {
  useEffect(() => {
    if (!vendorUid) return;

    const controller = new AbortController();

    const recordVisit = async () => {
      try {
        const referer = typeof document !== "undefined" ? document.referrer : undefined;
        await fetch(`${API_BASE_URL}/public/analytics/brands/visit`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ vendorUid, brandSlug, referer }),
          keepalive: true,
          signal: controller.signal,
        });
      } catch (error) {
        if (process.env.NODE_ENV !== "production") {
          console.warn("Failed to record brand visit", error);
        }
      }
    };

    recordVisit();

    return () => {
      controller.abort();
    };
  }, [vendorUid, brandSlug]);

  return null;
}
